<ng-container *ngIf="!isNoLayoutRoute; else noLayoutView">
  <app-mobile-view *ngIf="(layoutService.inMobile$ | async)"></app-mobile-view>
  
  <div class="flex flex-col min-h-screen" *ngIf="!(layoutService.inMobile$ | async)">
    <app-header *ngIf="(storageService.isLogged$ | async) && !(isPhysican)"></app-header>
    <app-announcement-banner *ngIf="storageService.isLogged$ | async"></app-announcement-banner>
  
    <div class="flex flex-col flex-grow">
      <router-outlet *ngIf="!(storageService.isLogged$ | async)"></router-outlet>
  
      <app-sidenav class="flex flex-grow" *ngIf="storageService.isLogged$ | async">
        <router-outlet></router-outlet>
  
        <ngx-spinner
          bdColor="rgba(255,255,255,0.7)"
          size="medium"
          color="#4663AE"
          type="square-jelly-box"
          [fullScreen]="true"
          [disableAnimation]="false"
        ></ngx-spinner>
      </app-sidenav>
    </div>
  
    <!-- FOOTER (GLOBAL) -->
    <app-footer></app-footer>
  </div>
</ng-container>

<ng-template #noLayoutView>
  <app-header class="hide-header" *ngIf="(storageService.isLogged$ | async) && !(isPhysican)"></app-header>
  <router-outlet></router-outlet>
  <ngx-spinner
    bdColor="rgba(255,255,255,0.7)"
    size="medium"
    color="#4663AE"
    type="square-jelly-box"
    [fullScreen]="true"
    [disableAnimation]="false"
  ></ngx-spinner>
</ng-template>
